import { Div, Text, TextColor } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import styles from './styles'

interface AllCapsTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: TextColor
}

export const AllCapsTitle: React.FC<AllCapsTitleProps> = props => {
  const { children, color = 'primaryBrand' } = props
  return (
    <Div css={styles.title}>
      <Text type="title" color={color} weight="bold">
        {children}
      </Text>
    </Div>
  )
}
